import { html } from "lit";
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import { ifDefined } from "lit/directives/if-defined.js";

export const Template = ({ className, variant, _slot }) => html`
    <ux-iws-sf-page class=${ifDefined(className)} variant=${ifDefined(variant)}>
        ${unsafeHTML(_slot)}
    </ux-iws-sf-page>
`;

export const exampleSlot = `
<ux-iws-sf-page-content>
    <ux-iws-sf-page-body>
        <h1>Page Title</h1>
        <p>This is a sample content for the page.</p>
    </ux-iws-sf-page-body>
    <ux-iws-sf-cta-footer>
        <p slot="text">You don’t have an account yet?</p>
        <ux-button slot="cta">Register now</ux-button>
    </ux-iws-sf-cta-footer>
</ux-iws-sf-page-content>
`;
